import React, { memo, useMemo, useState } from 'react'

import { FiltersSidebar, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, number, object, string } from 'prop-types'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

import { currentFilters } from './mock'

const cleanedFiltersLabels = (label) => label
  .replace(/,\s*,/g, ',')
  .replace(/,\s*\)/g, ')')
  .replace(/\(\s*,/g, '(')
  .replace(/,\s*,\s*/g, ', ')

const cleanedFiltersConfig = {
  ...currentFilters,
  label: null,
  filters: currentFilters.filters?.map(filter => ({
    ...filter,
    label: cleanedFiltersLabels(filter.label),
  })),
}

function FileFormatContent({ fileTypes, onFilterChange, textInputProps, limit = 8, hideShowMore = true }) {
  const translate = useTranslate()

  const [showAll, setShowAll] = useState(false)
  const filtersConfig = useMemo(() => [cleanedFiltersConfig], [])
  // limit=0 tells FiltersGroup to show all items (0 || initFilters.length = all)
  const effectiveLimit = !hideShowMore && showAll ? 0 : limit

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={filtersConfig}
        selectedFilters={fileTypes}
        onFiltersChange={onFilterChange}
        limit={effectiveLimit}
        isControlled
        hideLastDivider
        useNewCheckboxes
        hideShowMore
        searchPlaceholder={translate('search_page.filters.file_format.search_placeholder')}
        textInputProps={textInputProps}
        baseFormWrapperClassName="filter-wrapper__content"
      />
      {!hideShowMore && !showAll && (
        <Button
          type="ghost-primary"
          size="small"
          customClass="filter-wrapper__show-more cgt-link-primary"
          onClick={() => setShowAll(true)}
        >
          {translate('search_page.filters.file_format.show_more')}
        </Button>
      )}
      {!hideShowMore && showAll && (
        <Button
          type="ghost-primary"
          size="small"
          customClass="filter-wrapper__show-more cgt-link-primary"
          onClick={() => setShowAll(false)}
        >
          {translate('search_page.filters.file_format.show_less')}
        </Button>
      )}
    </>
  )
}

FileFormatContent.propTypes = {
  fileTypes: arrayOf(string).isRequired,
  onFilterChange: func.isRequired,
  textInputProps: object,
  limit: number,
  hideShowMore: bool,
}

export default memo(FileFormatContent)
